import { Link } from "react-router-dom";
import CompanyInformation from "../components/common/CompanyInformation";
import ChannelPartnerDisclosure from "../components/common/ChannelPartnerDisclosure";
import { BUSINESS_INFO } from "../constants/businessInfo";

const Footer = () => {
  return (
    <footer className="bg-[#0f172a] text-gray-50 border-t border-gray-700">
      <div className="max-w-6xl mx-auto px-6 py-8 text-center">
        {/* Logo & Short Intro */}
        <div className="flex flex-col items-center">
          <img
            src="/uploads/ec775a84-317a-4af0-a3f1-8e5194a9d9ec.jpg"
            alt="Mr. Chirag Ashok Thakkar"
            className="w-16 h-16 rounded-full object-cover border border-gray-300 shadow-sm mb-3"
          />
          <h3 className="text-base font-semibold text-gray-100">
            Thakkhar Realtors
          </h3>
          <p className="mt-2 text-sm max-w-2xl text-gray-300 leading-relaxed">
            Led by{" "}
            <span className="font-medium text-blue-500">
              Mr. Chirag Ashok Thakkar
            </span>
            , a certified MahaRERA Real Estate Agent with 10+ years of
            experience — helping you find your perfect property in Mumbai &
            Navi Mumbai.
          </p>
        </div>

        {/* Footer Links */}
        <div className="flex flex-wrap justify-center gap-6 mt-6 text-sm font-medium">
          <Link to="/about" className="hover:text-blue-500 transition">
            About
          </Link>
          <Link to="/services" className="hover:text-blue-500 transition">
            Services
          </Link>
          <Link to="/properties" className="hover:text-blue-500 transition">
            Properties
          </Link>
          <Link to="/blogs" className="hover:text-blue-500 transition">
            Blogs
          </Link>
          <Link to="/faq" className="hover:text-blue-500 transition">
            FAQ
          </Link>
          <Link to="/contact" className="hover:text-blue-500 transition">
            Contact
          </Link>
          <Link to="/privacy-policy" className="hover:text-blue-500 transition">
            Privacy Policy
          </Link>
          <Link to="/terms-and-conditions" className="hover:text-blue-500 transition">
            Terms & Conditions
          </Link>
        </div>

        <div className="mt-8 text-left">
          <CompanyInformation compact dark className="border-gray-700" />
        </div>

        <div className="mt-4 text-left">
          <ChannelPartnerDisclosure forceShow />
        </div>

        {/* Contact Info */}
        <div className="mt-6 text-sm text-gray-400">
          <p>
            🏢 {BUSINESS_INFO.officeAddressLine1}, {BUSINESS_INFO.officeAddressLine2}, {BUSINESS_INFO.city}, {BUSINESS_INFO.state} - {BUSINESS_INFO.pinCode}
          </p>
          <p className="mt-1">
            📞{" "}
            <a
              href={`tel:${BUSINESS_INFO.phone.replace(/\s+/g, "")}`}
              className="font-medium text-gray-300 hover:text-white hover:underline"
            >
              {BUSINESS_INFO.phone}
            </a>{" "}
            | ✉️{" "}
            <a
              href={`mailto:${BUSINESS_INFO.businessEmail}`}
              className="text-blue-500 hover:underline"
            >
              {BUSINESS_INFO.businessEmail}
            </a>
          </p>
        </div>

        {/* Social Icons */}
        <div className="flex justify-center gap-5 mt-5 text-gray-400 text-lg">
          <button
            type="button"
            aria-label="Facebook page coming soon"
            className="hover:text-blue-500"
          >
            <i className="fab fa-facebook-f"></i>
          </button>
          <button
            type="button"
            aria-label="Instagram page coming soon"
            className="hover:text-pink-500"
          >
            <i className="fab fa-instagram"></i>
          </button>
          <button
            type="button"
            aria-label="LinkedIn page coming soon"
            className="hover:text-blue-700"
          >
            <i className="fab fa-linkedin-in"></i>
          </button>
          <button
            type="button"
            aria-label="YouTube channel coming soon"
            className="hover:text-red-500"
          >
            <i className="fab fa-youtube"></i>
          </button>
        </div>

        {/* Copyright */}
        <p className="text-xs text-gray-500 mt-6">
          © {new Date().getFullYear()} Thakkhar Realtors. All Rights Reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
